var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',[_vm._v("Term 3 "),_c('v-divider'),_c('span',{staticStyle:{"font-size":"14px","margin-right":"10px"}},[_vm._v("Total Grade")]),_c('v-chip',{attrs:{"dark":"","label":"","large":"","color":"red"}},[_c('h3',[_vm._v(_vm._s(this.total.toFixed(2))+"%")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }